import { Typography } from '@mui/material'
import React, { useContext } from 'react'
import { Icons } from '../assets/icons'
import { toBoldStrings, useTranslation } from '../i18n/useTranslation'
import { useCommonCtx } from '../context/useCommonCtx'
import { FadingWraper } from './FadingWraper'
type Props = {
    type: 'BEST' | 'WORST'
    pos?: 'start' | 'end'
    fading?: boolean
}
export const ScaleHint = (p: Props) => {
    const { type, pos = 'end', fading = false } = p
    const t = useTranslation( useCommonCtx())

    return type === 'BEST' ? (
        <FadingWraper
            active={fading}
            className={`flex self-stretch justify-${pos}`}
        >
            <Typography
                variant="h6"
                className={`flex self-stretch justify-${pos} text-right font-bold items-center mt-2 mb-1`}
            >
                {toBoldStrings(t('top_scale_hint')).map((s, i, arr) => (
                    <Typography
                        variant={i % 2 === 1 ? 'h6' : 'body1'}
                        className={`${i % 2 === 1 ? 'font-bold ' : ''} ${
                            i < arr.length - 1 ? 'mr-2' : ''
                        }`}
                        key={i}
                    >
                        {s}
                    </Typography>
                ))}
                <Icons.Top />
            </Typography>
        </FadingWraper>
    ) : (
        <FadingWraper active={fading}             className={`flex self-stretch justify-${pos}`}
        >
            <Typography
                variant="h6"
                className={`flex self-stretch justify-${pos} text-right font-bold items-center mt-1 mb-2`}
            >
                {toBoldStrings(t('bottom_scale_hint')).map((s, i, arr) => (
                    <Typography
                        variant={i % 2 === 1 ? 'h6' : 'body1'}
                        className={`${i % 2 === 1 ? 'font-bold ' : ''} ${
                            i < arr.length - 1 ? 'mr-2' : ''
                        }`}
                        key={i}
                    >
                        {s}
                    </Typography>
                ))}
                <Icons.Bottom />
            </Typography>
        </FadingWraper>
    )
}
